<template>
  <div class="pt-4 mx-auto h-screen">
    <p class="font-semibold tracking-wider text-gray-500 pl-8">STEP 3/5</p>
    <p class="mb-2 text-2xl font-semiboldtracking-widest pl-8">Products</p>
    <ProductsForm />
  </div>
</template>

<script>
import ProductsForm from '~/components/app/ProductsForm'

export default {
    name:"ProductsPage",

    components: {
        ProductsForm
    }
}
</script>

<style>

</style>
